import * as React from "react";
import {
    PickersTextField as MaterialPickersTextField,
    PickersTextFieldProps,
} from "@mui/x-date-pickers/PickersTextField";

const PickersTextField: React.FunctionComponent<PickersTextFieldProps> = React.forwardRef(
    (props: PickersTextFieldProps, ref: React.Ref<HTMLDivElement>) => (
        <MaterialPickersTextField {...props} ref={ref} size="small" />
    ),
);

export default PickersTextField;